import React from "react";
import { Radar } from "react-chartjs-2";
import { Chart as ChartJS, RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend } from "chart.js";

import { CHART_FONT, CHART_GRID, CHART_INK, CHART_MUTED, CHART_SURFACE, tooltip } from "./chartTheme";

// Enregistrement des composants de Chart.js
ChartJS.register(RadialLinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

// `width`/`height` : la taille était écrite en dur (600 × 525 px), ce qui
// débordait de toute carte plus étroite. Les valeurs par défaut sont celles
// d'origine — les écrans qui ne passent rien ne bougent pas.
const RadarChart = ({ gameStatus, selectedMetrics, width = "600px", height = "525px" }) => {
  // Filtrer les métriques selon selectedMetrics
  const filteredMetrics = Object.keys(gameStatus.score_dic)
    .filter(key => selectedMetrics.includes(key))
    .map(key => ({ label: gameStatus.score_dic[key].name, value: gameStatus.score_dic[key].value }));

  // Extraire les labels et valeurs
  const labels = filteredMetrics.map(item => item.label);
  const values = filteredMetrics.map(item => item.value);

  // Le rose d'origine était la couleur par défaut de chart.js, et la seule de
  // toute la page à ne rien vouloir dire. Le bleu Hydros, lui, est déjà celui
  // des chiffres et des titres autour.
  const data = {
    labels: labels,
    datasets: [
      {
        label: "Métriques sélectionnées",
        data: values,
        backgroundColor: "rgba(53, 135, 161, 0.18)",
        borderColor: "#3587a1",
        borderWidth: 2,
        pointBackgroundColor: "#205673",
        pointBorderColor: CHART_SURFACE,
        pointBorderWidth: 2,
        pointRadius: 4,
        pointHoverRadius: 6,
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false // Désactive la légende
      },
      tooltip: tooltip(),
      datalabels: { display: false },
    },
    scales: {
      r: {
        suggestedMin: 0,
        suggestedMax: 10,
        angleLines: { color: CHART_GRID },
        grid: { color: CHART_GRID },
        pointLabels: {
          color: CHART_INK,
          font: {
            family: CHART_FONT,
            size: 13,
            weight: "700"
          }
        },
        // Les graduations flottent au milieu de la toile : sans fond opaque
        // elles se confondent avec les lignes, avec un fond blanc elles
        // percent le tracé. Discrètes et sans fond.
        ticks: {
          backdropColor: "transparent",
          color: CHART_MUTED,
          font: { family: CHART_FONT, size: 11 },
          stepSize: 2,
        }
      }
    }
  };

  return (
    <div className="water-footprint-container">
      <div className="water-footprint-title">Autres métriques du projet</div>
      <div style={{ width, height }}>
        <Radar data={data} options={options} />
      </div>
    </div>
  );
};

export default RadarChart;
